// Centralized sessionStorage keys. Always import from here instead of using
// raw strings so refactors stay in sync across the codebase.
export const SESSION_STORAGE_KEYS = {
  SEQUENCE_ID: 'sequence_id',
} as const;
